import React, { useEffect, Fragment } from 'react';
import SelectField from './../Form/SelectField';
import {
    changeFrontAll,
    changeDepartment1All,
    changeAddressAll,
    changeAddress2All,
} from './../CanvasActions';

const FormP12 = React.memo((props) => {
    useEffect(() => {
        changeFrontAll(props.front);
    }, [props.front]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    let title = '';
    let addressContainer = null;
    if (props.templateCode === 'p12t1') {
        title = 'UTHealth Houston | School of Biomedical Informatics Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>7000 Fannin Street, 6th Floor</div>
                <div>Houston, Texas 77030</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t2') {
        title = 'UTHealth Houston | School of Dentistry Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>7500 Cambridge Street</div>
                <div>Houston, Texas 77054</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t3') {
        title = 'UTHealth Houston | Cizik School of Nursing Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>6901 Bertner Avenue</div>
                <div>Houston, Texas 77030</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t4') {
        title = 'UTHealth | School of Public Health Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>1200 Pressler Street</div>
                <div>Houston, Texas 77030</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t5') {
        title = 'UTHealth Houston | McGovern Medical School Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>6431 Fannin Street</div>
                <div>Houston, Texas 77030</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t6') {
        title = 'MD Anderson Cancer Center | UTHealth Houston Graduate School Foldover Thank You Cards and Envelopes';
        addressContainer = (
            <Fragment>
                <div>6767 Bertner Avenue</div>
                <div>Houston, Texas 77030</div>
            </Fragment>
        );
    } else if (props.templateCode === 'p12t7') {
        title = 'UTHealth Houston | General Thank You Cards and Envelopes';
    } else if (props.templateCode === 'p12t8') {
        title = 'UTHealth Houston | McWilliams School of Biomedical Informatics Thank You Cards and Envelopes';
    } else if (props.templateCode === 'p12t9') {
        title = 'UTHealth Houston | School of Public Health Thank You Cards and Envelopes';
    } else if (props.templateCode === 'p12t10') {
        title = 'UTHealth Houston | UTHealth Behavioral Sciences Thank You Cards and Envelopes';
    }

    const checkAddEnvelopes = (event) => {
        let value = event.target.checked ? 1 : 0;
        props.setAddEnvelopes(value);
    };

    let quantityOptions = [
        { value: 1, label: 'White' },
        { value: 2, label: 'Grey' },
        { value: 3, label: 'Orange' },
        { value: 4, label: 'Gulf Blue' },
    ];
    if (props.templateCode === 'p12t6') {
        quantityOptions = [
            { value: 1, label: 'White' },
            { value: 2, label: 'Grey' },
        ];
    }

    const changeHandler = (setFunction, event) => {
        let value = event.target.value.replace(/ +(?= )/g, '');
        setFunction(value);
    };

    let departmentField = null;
    let address1Field = null;
    let address2Field = null;

    if (props.templateCode === 'p12t7') {
        departmentField = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">Office, Center, Department, Institute, Program:</div>
                <input
                    type="text"
                    value={props.department1}
                    onChange={changeHandler.bind(this, props.setDepartment1)}
                    placeholder="Enter your mailing address"
                />
            </div>
        );
        address1Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">Address, Suite:</div>
                <input
                    type="text"
                    value={props.address}
                    onChange={changeHandler.bind(this, props.setAddress)}
                    placeholder="Enter your mailing address"
                />
            </div>
        );
        address2Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">City, State, Zip:</div>
                <input
                    type="text"
                    value={props.address2}
                    onChange={changeHandler.bind(this, props.setAddress2)}
                    placeholder="Enter your City, State, Zip"
                />
            </div>
        );
    } else if (props.templateCode === 'p12t8') {
        address1Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">Address, Suite:</div>
                <input
                    type="text"
                    value={props.address}
                    onChange={changeHandler.bind(this, props.setAddress)}
                    placeholder="Enter your mailing address"
                />
            </div>
        );
        address2Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">City, State, Zip:</div>
                <input
                    type="text"
                    value={props.address2}
                    onChange={changeHandler.bind(this, props.setAddress2)}
                    placeholder="Enter your City, State, Zip"
                />
            </div>
        );
    } else if (props.templateCode === 'p12t9') {
        address1Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">Address, Suite:</div>
                <input
                    type="text"
                    value={props.address}
                    onChange={changeHandler.bind(this, props.setAddress)}
                    placeholder="Enter your mailing address"
                />
            </div>
        );
        address2Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">City, State, Zip:</div>
                <input
                    type="text"
                    value={props.address2}
                    onChange={changeHandler.bind(this, props.setAddress2)}
                    placeholder="Enter your City, State, Zip"
                />
            </div>
        );
    } else if (props.templateCode === 'p12t10') {
        address1Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">Address, Suite:</div>
                <input
                    type="text"
                    value={props.address}
                    onChange={changeHandler.bind(this, props.setAddress)}
                    placeholder="Enter your mailing address"
                />
            </div>
        );
        address2Field = (
            <div className="envelope-field mt-2 mb-1">
                <div className="label">City, State, Zip:</div>
                <input
                    type="text"
                    value={props.address2}
                    onChange={changeHandler.bind(this, props.setAddress2)}
                    placeholder="Enter your City, State, Zip"
                />
            </div>
        );
    }

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Layout"
                value={props.front}
                setFunction={props.setFront}
                options={quantityOptions}
            />
            <div className="field envelope-field">
                <div className="matching-checkbox">
                    <input
                        type="checkbox"
                        checked={props.addEnvelopes}
                        onClick={checkAddEnvelopes}
                    />
                    &nbsp;
                    Add matching A6 envelopes:
                </div>
                {departmentField}
                {address1Field}
                {address2Field}
                {addressContainer}
            </div>
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> {title}</div>
                <div className="description-list">
                    <span className="label">Thank You Card:</span>
                    <ul>
                        <li>Flat: 6" x 9"</li>
                        <li>Folded: 6" x 4.5" (Finish Size)</li>
                        <li>Stock: 100# Opaque White Cover</li>
                        <li>Printed: Color one side</li>
                    </ul>
                </div>
                <div className="description-list">
                    <span className="label">A6 Envelope:</span>
                    <ul>
                        <li>Flat: 6.5" x 4.75"</li>
                        <li>Stock: A6 Opaque White</li>
                        <li>Printed: Color one side</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP12;
